import qdashAxios from './axios';
import config from '../config';

export async function getSiteIds() {
    const url = `${config.openApiUrl}/getSiteIds`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function getAdminSiteIds() {
    const url = `${config.restrictedApiUrl}/getSitesByRoles`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function getCategories() {
    const url = `${config.openApiUrl}/getCategories`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function createDashboard(newDashboard) {
    const url = `${config.restrictedApiUrl}/postDashboard`;
    const result = await qdashAxios.post(url, newDashboard);
    return result.data;
}

export async function deleteDashboard(dashboard) {
    let url = `${config.restrictedApiUrl}/deleteDashboard`;
    const result = await qdashAxios.delete(url, { data: dashboard });
    return result.data;
}

export async function getDashboardsBySite(siteId, searchTerm) {
    let url = `${config.restrictedApiUrl}/getDashboardsBySite?siteId=${siteId}`;

    if (searchTerm) {
        url += `&searchTerm=${searchTerm}`;
    }
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function updateDashboard(dashboard) {
    let url = `${config.restrictedApiUrl}/putDashboard`;

    const result = await qdashAxios.put(url, dashboard);
    return result.data;
}

export async function updateDashboards(dashboards) {
    let url = `${config.restrictedApiUrl}/putDashboards`;

    const result = await qdashAxios.put(url, dashboards);
    return result.data;
}

export async function updateDashboardLinks(links) {
    let url = `${config.restrictedApiUrl}/putLinks`;

    const result = await qdashAxios.put(url, links);
    return result.data;
}

export async function addInfoItem(newInfoItem) {
    let url = `${config.restrictedApiUrl}/postInfoItem`;
    const result = await qdashAxios.post(url, newInfoItem);
    return result.data;
}

export async function updateInfoItem(infoItem) {
    let url = `${config.restrictedApiUrl}/putInfoItem`;
    const result = await qdashAxios.put(url, infoItem);
    return result.data;
}

export async function deleteInfoItem(infoItem) {
    let url = `${config.restrictedApiUrl}/deleteInfoItem`;
    const result = await qdashAxios.delete(url, { data: infoItem });
    return result.data;
}

export async function getDashboard(siteId, dashboardId) {
    let url = `${config.openApiUrl}/getLinksByDashboard?siteId=${siteId}&dashboardId=${dashboardId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function getDashboardRestricted(siteId, dashboardId) {
    let url = `${config.restrictedApiUrl}/getLinksByDashboard?siteId=${siteId}&dashboardId=${dashboardId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function addLink(newLink) {
    let url = `${config.restrictedApiUrl}/postLink`;
    const result = await qdashAxios.post(url, newLink);
    return result.data;
}

export async function getUrl(siteId, dashboardId, linkId) {
    let url = `${config.openApiUrl}/getLinkUrl?siteId=${siteId}&dashboardId=${dashboardId}&linkId=${linkId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function getLink(siteId, dashboardId, linkId) {
    let url = `${config.restrictedApiUrl}/getLink?siteId=${siteId}&dashboardId=${dashboardId}&linkId=${linkId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function editLink(link) {
    let url = `${config.restrictedApiUrl}/putLink`;
    const result = await qdashAxios.put(url, link);
    return result.data;
}

export async function deleteLink(siteId, dashboardId, linkId) {
    let url = `${config.restrictedApiUrl}/deleteLink`;
    const result = await qdashAxios.delete(url, { data: { siteId, dashboardId, linkId } });
    return result.data;
}

export async function sendContactRequest(content) {
    let url = `${config.openApiUrl}/postContactForm`;
    const result = await qdashAxios.post(url, content);
    return result.data;
}

export async function sendAppFeedback(content) {
    let url = `${config.openApiUrl}/postAppFeedback`;
    const result = await qdashAxios.post(url, content);
    return result.data;
}

export async function sendLinkFeedback(feedback) {
    let url = `${config.openApiUrl}/postLinkFeedback`;
    const result = await qdashAxios.post(url, feedback);
    return result.data;
}

export async function sendLinkRequest(linkRequest) {
    let url = `${config.openApiUrl}/postLinkRequest`;
    const result = await qdashAxios.post(url, linkRequest);
    return result.data;
}

export async function getLinksByDashboard(siteId, dashboardId) {
    let url = `${config.restrictedApiUrl}/getLinksByDashboard?siteId=${siteId}&dashboardId=${dashboardId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function deleteDashboards(dashboardIds) {
    let url = `${config.restrictedApiUrl}/deleteDashboards`;
    const result = await qdashAxios.delete(url, { data: dashboardIds });
    return result.data;
}

export async function deleteLinks(linkIds) {
    let url = `${config.restrictedApiUrl}/deleteLinks`;
    const result = await qdashAxios.delete(url, { data: linkIds });
    return result.data;
}

export async function updateLinks(links) {
    let url = `${config.restrictedApiUrl}/putLinks`;
    const result = await qdashAxios.put(url, links);
    return result.data;
}

export async function sendLinkHit(siteId, dashboardId, linkId) {
    let url = `${config.openApiUrl}/postLinkHit`;
    const result = await qdashAxios.post(url, { siteId, dashboardId, linkId });
    return result.data;
}

export async function getMyDashboards() {
    let url = `${config.restrictedApiUrl}/getMyDashboards`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function addContributor(newContributor) {
    const url = `${config.restrictedApiUrl}/postContributor`;
    const result = await qdashAxios.post(url, newContributor);
    return result.data;
}

export async function getContributorsByDashboard(siteId, dashboardId) {
    let url = `${config.restrictedApiUrl}/getContributorsForDashboard`;
    const result = await qdashAxios.get(url, { siteId, dashboardId });
    return result.data;
}

export async function updateContributor(updatedContributor) {
    let url = `${config.restrictedApiUrl}/putContributor`;
    const result = await qdashAxios.put(url, updatedContributor);
    return result.data;
}

export async function deleteContributor(contributor) {
    let url = `${config.restrictedApiUrl}/deleteContributor`;
    const result = await qdashAxios.delete(url, { data: contributor });
    return result.data;
}

export async function uploadDashboardPhoto(siteId, dashboardId, photo) {
    let url = `${config.restrictedApiUrl}/site/${siteId}/dashboard/${dashboardId}/attachment`;

    var formData = new FormData();
    formData.append('file', photo);

    const result = await qdashAxios.post(url, formData);
    return result.data;
}

export async function deleteDashboardPhoto(siteId, dashboardId) {
    let url = `${config.restrictedApiUrl}/site/${siteId}/dashboard/${dashboardId}/attachment`;
    const result = await qdashAxios.delete(url);
    return result.data;
}

export async function captureAnalyticsEvent(event) {
    let url = `${config.openApiUrl}/postEvent`;
    const result = await qdashAxios.post(url, event);
    return result.data;
}

export async function getUserFavoriteDashboards() {
    const url = `${config.restrictedApiUrl}/getFavorites`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function getUserFavoriteDashboardsBySiteId(siteId) {
    const url = `${config.restrictedApiUrl}/getFavorites?siteId=${siteId}`;
    const result = await qdashAxios.get(url);
    return result.data;
}

export async function addUserFavoriteDashboard(dashboardId, siteId) {
    const url = `${config.restrictedApiUrl}/postFavorite?dashboardId=${dashboardId}&siteId=${siteId}`;
    const result = await qdashAxios.post(url);
    return result.data;
}

export async function deleteUserFavoriteDashboard(dashboardId) {
    const url = `${config.restrictedApiUrl}/deleteFavorite?dashboardId=${dashboardId}`;
    const result = await qdashAxios.delete(url);
    return result.data;
}

export async function sendDashboardHit(siteId, dashboardId) {
    let url = `${config.openApiUrl}/postDashboardHit`;
    const result = await qdashAxios.post(url, { siteId, dashboardId});
    return result.data;
}
